import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { DocumentService } from '../services/document-service';

@Injectable({
  providedIn: 'root'
})
export class PublicDocumentGuard {
  constructor(
    private documentService: DocumentService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> {
    const uuid = route.paramMap.get('uuid');
    
    if (!uuid) {
      return new Observable(observer => {
        observer.next(this.router.createUrlTree(['/access']));
        observer.complete();
      });
    }

    return this.documentService.VerifierAccessPublic(uuid).pipe(
      map(response => {
        if (response.body) {
          return true;
        }
        return this.router.createUrlTree(['/access']);
      })
    );
  }
} 